if (!customElements.get('learning-experience')) {
  class LearningExperience extends HTMLElement {
    constructor() {
      super();
      this.items = null;
      this.labels = null;
      this.circles = null;
    }

    connectedCallback() {
      this.items = this.querySelectorAll('.learning-experience__item');
      this.labels = this.querySelectorAll('.learning-experience__label');
      this.circles = this.querySelectorAll('.learning-experience__circle');

      if (!this.items || this.items.length === 0) return;

      this.initBreathing();
      this.attachInteractions();
    }

    initBreathing() {
      if (!this.circles || this.circles.length === 0) return;

      const CX = 213;
      const CY = 196;
      const R = 110;
      const angle = Math.PI / 3;

      const positions = [
        { x: CX - R, y: CY },
        { x: CX + R * Math.cos(angle), y: CY - R * Math.sin(angle) },
        { x: CX + R * Math.cos(angle), y: CY + R * Math.sin(angle) },
      ];

      const setPosition = (i, x, y) => {
        const circle = this.circles[i];
        const label = this.labels ? this.labels[i] : null;

        if (circle) {
          circle.setAttribute('cx', x);
          circle.setAttribute('cy', y);
        }
        if (label) {
          label.setAttribute('x', x);
          label.setAttribute('y', y);
          label.querySelectorAll('tspan').forEach((span) => {
            span.setAttribute('x', x);
          });
        }
      };

      positions.forEach((pos, i) => setPosition(i, pos.x, pos.y));

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduceMotion || typeof gsap === 'undefined') return;

      const state = { breath: 0 };
      gsap.to(state, {
        breath: 1,
        duration: 4,
        ease: 'sine.inOut',
        repeat: -1,
        yoyo: true,
        onUpdate: () => {
          const pull = state.breath * 0.15;
          positions.forEach((pos, i) => {
            const x = pos.x + (CX - pos.x) * pull;
            const y = pos.y + (CY - pos.y) * pull;
            setPosition(i, x, y);
          });
        },
      });
    }

    attachInteractions() {
      if (this.labels) {
        this.labels.forEach((label) => {
          const idx = Number(label.dataset.index);
          if (Number.isNaN(idx)) return;

          label.addEventListener('mouseenter', () => this.setActive(idx));
          label.addEventListener('focus', () => this.setActive(idx));
        });
      }

      if (this.items) {
        this.items.forEach((item) => {
          const idx = Number(item.dataset.index);
          if (Number.isNaN(idx)) return;

          item.addEventListener('mouseenter', () => this.setActive(idx));
          const link = item.querySelector('.learning-experience__item-link');
          if (link) {
            link.addEventListener('focus', () => this.setActive(idx));
          }
        });
      }
    }

    setActive(index) {
      if (!this.items) return;
      this.items.forEach((item, i) => {
        item.classList.toggle('learning-experience__item--active', i === index);
      });
    }
  }

  customElements.define('learning-experience', LearningExperience);
}
